import { Address } from "./address";
import { Contract } from "./contract";
import { User } from "./user";

export class Company {
    id?: string;
    number?: number;
    name?: string;
    description?: string;
    email?: string;
    ntva?: string;
    contactName?: string;
    disabled?: boolean;
    address?: Address;

    creationDate?: Date;
    creationUser?: User;

    modifiedDate?: Date;
    modifiedUser?: User;

    contracts?: Contract[];

    constructor(company?: Company) {
        this.id = company?.id;
        this.number = company?.number;
        this.name = company?.name;
        this.description = company?.description;
        this.email = company?.email;
        this.ntva = company?.ntva;
        this.contactName = company?.contactName;
        this.disabled = company?.disabled;
        this.address = company?.address;

        this.creationDate = company?.creationDate;
        this.creationUser = company?.creationUser;
        this.modifiedDate = company?.modifiedDate;
        this.modifiedUser = company?.modifiedUser;

        this.contracts = company?.contracts || [];
    }
}
